import { render, staticRenderFns } from "./SnowDataTableDropdown.vue?vue&type=template&id=028a2750&scoped=true&"
import script from "./SnowDataTableDropdown.vue?vue&type=script&lang=js&"
export * from "./SnowDataTableDropdown.vue?vue&type=script&lang=js&"
import style0 from "./SnowDataTableDropdown.vue?vue&type=style&index=0&id=028a2750&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "028a2750",
  null
  
)

export default component.exports